const _import = require("../_import")
import error from "./empty.vue"
import Layout from "@/page/index/"
import Approval from "@/views/foreign_Invitation_manage/approval.vue"
import ApprovalList from "@/views/foreign_Invitation_manage/approval_list.vue"
import SetupApproval from "@/views/foreign_set_up/mobile_approval.vue"
import PromiseText from "@/views/foreign_abroad_exchange/promise_text"
import DocumentApproval from "@/views/foreign_abroad_exchange/mobile_approval"
import returnVisitTable from "@/views/foreign_abroad_exchange/return_visit_table"
import eightItemsStipulateTable from "@/views/foreign_set_up/components/eight_items_stipulate_table"
import Mobile from "@/views/mobile/index.vue"
import VisitReportEdit from '@/views/foreign_set_up/visit_report_edit.vue'
import VisitReportDetail from '@/views/foreign_set_up/visit_report_detail.vue'

export default [
    {
        path: "/login",
        name: "登录页",
        component: _import("login/index"),
        meta: {
            keepAlive: true,
            appId: "00f6d65d16024043a3d8260192f1cb35"
        }
    },
        {
        path: "/error",
        component: error,
        name: "error"
    },
    {
        path: "/blank",
        component: _import("errlog/blank"),
        name: "blank"
    },
    {
        path: "/mobile-approval",
        name: "mobile_approval",
        component: Approval
    },
    {
        path: "/mobile",
        name: "mobile",
        component: Mobile
    },
    {
        path: "/mobile-approval-setup",
        name: "mobile_approval_setup",
        component: SetupApproval
    },
    {
        path: "/mobile-approval-document",
        name: "mobile_approval_document",
        component: DocumentApproval
    },
    {
        path: "/mobile-approval-list",
        name: "mobile_approval_list",
        component: ApprovalList
    },
    {
        path: "/promise_text",
        name: "promise_text",
        component: PromiseText
    },
    {
        path: "/return_visit_table",
        name: "return_visit_table",
        component: returnVisitTable
    },
    {
        path: "/eight_items_stipulate_table",
        name: "eight_items_stipulate_table",
        component: eightItemsStipulateTable
    },
    {
        path: '/visit_report_edit',
        name: 'VisitReportEdit',
        component: VisitReportEdit,
        meta: {
            title: '出访报告'
        }
    },
    {
        path: '/visit_report_detail',
        name: 'VisitReportDetail',
        component: VisitReportDetail,
        meta: {
            title: '出访报告'
        }
    },
    {
        path: '/set_up/company_setup/travel_page',
        name: 'travel_page',
        component: _import("foreign_set_up/components/travel_page", "views"),
        meta: {
            title: '成行情况'
        }
    },
    {
        path: '/set_up/company_setup/travel_page_disabled',
        name: 'travel_page_disabled',
        component: _import("foreign_set_up/components/travel_page_disabled", "views"),
        meta: {
            title: '成行情况'
        }
    },
    {
        path: "/set_up/group-info-byoaseal",
        name: "group-info-byoaseal",
        component: _import("foreign_set_up/group_info_byoaseal", "views")
    },
    {
        path: "/print_receive",
        name: "print_receive",
        component: _import("foreign_set_up/receive_detail", "views")
    },
    {
        path: "/speal_note",
        name: "speal_note",
        component: _import("foreign_set_up/speal_note", "views")
    },
    {
        path: "/delay_speal_note",
        name: "delay_speal_note",
        component: _import("foreign_set_up/delay_speal_note", "views")
    },
    {
        path: "/HK_matter_list",
        name: "HK_matter_list",
        component: _import("foreign_set_up/HK_matter_list", "views")
    },
    {
        path: "/work_matter_list",
        name: "work_matter_list",
        component: _import("foreign_set_up/work_matter_list", "views")
    },
    {
        path: "/training_issue_list",
        name: "training_issue_list",
        component: _import("foreign_set_up/training_issue_list", "views")
    },
    {
        path: "/personal_info_list",
        name: "personal_info_list",
        component: _import("foreign_set_up/personal_info_list", "views")
    },
    {
        path: "/employment_period_list",
        name: "employment_period_list",
        component: _import("foreign_set_up/employment_period_list", "views")
    },
    {
        path: "/taiwan_speal_note",
        name: "taiwan_speal_note",
        component: _import("foreign_set_up/taiwan_speal_note", "views")
    },
    {
        path: "/assets_ask_note",
        name: "assets_ask_note",
        component: _import("foreign_set_up/assets_ask_note", "views")
    },
    {
        path: "/person_table",
        name: "person_table",
        component: _import("foreign_set_up/person_table", "views")
    },
    {
        path: "/work_table",
        name: "work_table",
        component: _import("foreign_set_up/work_table", "views")
    },
    {
        path: "/visit_table",
        name: "visit_table",
        component: _import("foreign_set_up/visit_table", "views")
    },
    {
        path: "/employed_table",
        name: "employed_table",
        component: _import("foreign_set_up/employed_table", "views")
    },
    {
        path: "/train_table",
        name: "train_table",
        component: _import("foreign_set_up/train_table", "views")
    },
    // train_table
    // employed_table
    {
        path: "/print_cancellation",
        name: "print_cancellation",
        component: _import("foreign_abroad_exchange/print_cancellation", "views")
    },
    {
        path: "/print_exchange",
        name: "print_exchange",
        component: _import("foreign_abroad_exchange/print_exchange", "views")
    },
    {
        path: "/print_record",
        name: "print_record",
        component: _import("foreign_set_up/print_record", "views")
    },
    {
        path: "/fingerprint_declaration",
        name: "fingerprint_declaration",
        component: _import("foreign_set_up/fingerprint_declaration", "views")
    },
    {
        path: "/usbkey_application_form",
        name: "usbkey_application_form",
        component: _import("foreign_licence_manage/usbkey_application_form", "views")
    },
    { path: "/company_on_record", name: "company_on_record", component: _import("foreign_on_record/company_record", "views") },
    {
        path: "/lock",
        name: "锁屏页",
        component: _import("lock/index"),
        meta: { appId: "00f6d65d16024043a3d8260192f1cb35" }
    },
    {
        path: "/404",
        component: _import("error-page/404", "components"),
        name: "404"
    },
    {
        path: "/403",
        component: _import("error-page/403", "components"),
        name: "403"
    },
    {
        path: "/500",
        component: _import("error-page/500", "components"),
        name: "500"
    },
    {
        path: "/",
        name: "主页",
        redirect: "index",
        component: Layout,
        children: [
            {
                path: "index",
                name: "indexPage",
                component: _import("foreign_index/index", "views")
            }
        ]
    },
    {
        path: "/myiframe",
        component: Layout,
        redirect: "/myiframe",
        children: [
            {
                path: ":routerPath",
                name: "iframe",
                component: _import("iframe/main", "components"),
                props: true
            }
        ]
    },
    {
        path: "/choose_company",
        name: "choose_company",
        component: _import("foreign_choose_company/index", "views")
    },
    {
    path: "/foreign",
    component: Layout, // 使用 Layout 组件保持头部导航
    name: "foreign",
    // 直接访问 /foreign（如零信任登录回跳）时兜底到首页，避免落在空白页
    redirect: "/index",
    meta: {
        title: "企业备案"
    },
    children: [
        {
            path: '/foreign/visit_plan_manage_detail',
            name: 'visit_plan_manage_detail',
            component: () => import('@/views/foreign_on_record/visit_plan_manage_detail.vue')
        }
    ]
    }
]
